import React from 'react'

import { nanoid } from 'nanoid'
import * as ToastifyLib from 'react-toastify'

import { TOAST_HOST_ID } from './constants'
import { Toast } from './Toast'
import { DismissableToastId, LaunchToastProps } from './types'

export const dismissToast = ({ id }: { id: DismissableToastId }) => {
  ToastifyLib.toast.dismiss(id)
}

const launchToast = (props: LaunchToastProps) => {
  const { autoCloseDelayMs, id, containerId, ...toastProps } = props
  const toastId = id ?? nanoid()
  const canDismiss = toastProps.dismissable !== false

  const handleDismiss = () => {
    if (canDismiss) {
      ToastifyLib.toast.dismiss(toastId)
    }
  }

  ToastifyLib.toast(() => <Toast {...toastProps} onDismiss={handleDismiss} />, {
    toastId,
    containerId,
    autoClose: autoCloseDelayMs,
  })
}

export const launchScriptToast = ({
  id,
  message,
  type = 'error',
  autoDismiss = false,
  dismissable = true,
}: {
  message: string
  id?: string // if undefined, a guid will be assigned instead
  type?: 'warning' | 'error'
  autoDismiss?: boolean
  dismissable?: boolean
}) => {
  launchToast({
    containerId: 'script-notifications',
    icon: 'fa fa-exclamation-circle',
    id,
    message: <div dangerouslySetInnerHTML={{ __html: message }}></div>,
    type,
    dismissable,
    autoCloseDelayMs: autoDismiss ? 6000 : undefined,
  })
}

export const launchExplorerToast = (
  props: Omit<LaunchToastProps, 'containerId'>,
) => launchToast({ ...props, containerId: TOAST_HOST_ID.FOLDER_EXPLORER })
